var fn = function( obj ){
var __t,__p='';
__p+='attribute vec3 aPosition;\nattribute vec3 aNormal;\n\nuniform mat4 uWorldMatrix;\nuniform mat4 uVP;\nuniform mat4 uRefMatrix;\n\nvarying vec3 vLocalPos;\nvarying vec3 vWorldNormal;\n  \n\n\nvec3 rotate( mat4 m, vec3 v )\n{\n  return m[0].xyz*v.x + m[1].xyz*v.y + m[2].xyz*v.z;\n}\n\n  \nvoid main( void ){\n  vec4 worldPos = uWorldMatrix * vec4( aPosition, 1.0 );\n  gl_Position = uVP * worldPos;\n  vLocalPos = (uRefMatrix*worldPos).xyz;\n  vWorldNormal = normalize( rotate( uWorldMatrix, aNormal ) );\n}\n';
return __p;
};
fn.toString=fn;
module.exports = fn;